import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

const variantStyles = {
  h1: `
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    @media ${breakpoints.sm} {
      font-size: 28px;
      line-height: 33.6px;
    }
  `,
  h2: `
    font-size: 28px;
    font-weight: 700;
    line-height: 33.6px;
    @media ${breakpoints.sm} {
      font-size: 22px;
      font-weight: 900;
      line-height: 26.4px;
    }
  `,
  h3: `
    font-size: 20px;
    font-weight: 900;
    line-height: 24px;
    @media ${breakpoints.sm} {
      font-size: 18px;
      line-height: 21.6px;
    }
  `,
  h4: `
    font-size: 16px;
    font-weight: 700;
    line-height: 21.6px;
    @media ${breakpoints.sm} {
      font-size: 14px;
      font-weight: 600;
      line-height: 16.8px;
    }
  `,
  body1: `
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  `,
  small: `
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
`,
};

const colorStyles = {
  primary: "var(--white-primary)",
  secondary: "var(--white-ghost)",
  whiteSecondary: "var(--white-secondary)",
  orange: "var(--orange-primary)",
};

export const StyledTypography = styled.span`
  ${({ variant }) => variantStyles[variant]};
  color: ${({ color }) => colorStyles[color]};
  font-weight: ${({ semibold }) => semibold && "600"};
`;
